import { HttpParams } from '@angular/common/http';
import { FiltreParametre } from '@core-lib/enums';
import { IDatagridSettings, IList, IOperationCommentaireCreateForm } from '@core-lib/models';
import { IAffaireDepot, IOperationCreationRelated } from 'projects/app-back/src/app/shared-module/models';

export function extractToList<T>(list: IList<T>): T[] {
	return list.items;
}

export function getListApiParamsFromDatagrid(settings: IDatagridSettings<any>, filtreParametre? : FiltreParametre): HttpParams {
	let httpParams = new HttpParams();
	if (settings.options.hasSort && settings.sort.column) {
		httpParams = httpParams.append('sortBy', `${settings.sort.column} ${settings.sort.isAsc ? 'asc' : 'desc'}`);
	}

	if (settings.options.hasPaging) {
		httpParams = httpParams.append('pageNumber', '' + settings.pageNumber).append('pageSize', '' + settings.pageSize);
	}
	if(filtreParametre != null){
		httpParams = httpParams.append('filtreParametre', filtreParametre);
	}	
	return httpParams;
}

export function createCreationModel(
	operation: IAffaireDepot,
	operationCommentaire: IOperationCommentaireCreateForm
): IOperationCreationRelated {
	let result: IOperationCreationRelated = { createDepotRequestDto: operation, soumettreCommanddto: operationCommentaire };
	return result;
}
